import React, { useEffect, useMemo, useState } from "react"
import { Col, Row, CardTitle, Label, Input, Button } from "reactstrap"
import Select, { components } from "react-select"
import {
  checkExtension,
  getBusinsessAddress,
  renderAddressValue,
  showRegistrationType,
} from "helpers/common"
import { Link } from "react-router-dom"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import imageIcon from "../../../assets/images/icons/image.svg"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { reactSelectStyles } from "helpers/utils"
import { depositories } from "helpers/depositories"

const CustomDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <></>
    </components.DropdownIndicator>
  )
}
const NonIndividualView = ({ profileData }) => {
  const politicalExposeOptions = [
    "Not Applicable",
    "Politically Exposed Person",
    "Related to Politically Exposed Person",
  ]

  const businessFiles = [
    { key: "initial_partnership_deed", label: "Initial Partnership Deed" },
    { key: "latest_partnership_deed", label: "Latest Partnership Deed" },
    {
      key: "certificate_of_incorporation",
      label: "Certificate of Incorporation",
    },
    { key: "gstin_certificate", label: "GSTIN Certificate" },
    { key: "memorandum_of_association", label: "Memorandum of Association" },
    { key: "articles_of_association", label: "Articles of Association" },
    { key: "initial_llp_deed", label: "Initial LLP Deed" },
    { key: "latest_llp_deed", label: "Latest LLP Deed" },
    { key: "huf_creation_document", label: "HUF Creation Document" },
    { key: "trust_deed", label: "Trust Deed" },
    { key: "society_bye_laws", label: "Society Bye-laws" },
  ]

  const getDepositoryParticipantValue = () => {
    const v = profileData?.dematDetails.depository_participant_name
    return {
      label: v,
      value: v,
    }
  }

  const hasBusinessFile = () => {
    if (!profileData?.companyAdditionalDetails) return false

    for (const { key } of businessFiles) {
      if (profileData.companyAdditionalDetails[key]) {
        return true
      }
    }
    return false
  }
  return (
    <>
      <Row>
        <Col xl={12}>
          <div>
            <div>
              <Row className="mt-3 mb-2">
                {profileData?.companyDetails && (
                  <>
                    <CardTitle className="mb-4">
                      {profileData?.investor?.entity_type === "INDIVIDUAL"
                        ? "Personal Details"
                        : "Entity Details"}
                    </CardTitle>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Name of the Entity
                      </Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={profileData?.companyDetails?.entity_name}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Constitution of Business
                      </Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={
                          profileData?.companyDetails?.constitution_of_business
                        }
                      />
                    </Col>

                    <Col xl={6}>
                      <Label className="col-form-label">
                        Registered Address
                      </Label>
                      <Input
                        disabled
                        name="name"
                        type="textarea"
                        className="form-control"
                        value={getBusinsessAddress(profileData?.companyDetails)}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Communication Address
                      </Label>
                      <Input
                        disabled
                        name="name"
                        type="textarea"
                        className="form-control"
                        value={
                          profileData?.companyDetails?.is_comm_address_same ===
                          "SAME"
                            ? getBusinsessAddress(profileData?.companyDetails)
                            : renderAddressValue(
                                profileData?.companyDetails
                                  ?.communication_address
                              )
                        }
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">GSTIN</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={
                          profileData?.companyDetails?.gstin || "Not Applicable"
                        }
                      />
                    </Col>
                  </>
                )}
                {profileData?.companyAdditionalDetails?.politicalExposure && (
                  <Col xl={6}>
                    <Label className="col-form-label">Political Exposure</Label>
                    <div className="input-wrapper">
                      <select
                        disabled={true}
                        id="politicalExposure"
                        name="politicalExposure"
                        className={`form-select pageSizewith-icon`}
                        value={
                          profileData?.companyAdditionalDetails
                            ?.politicalExposure
                        }
                      >
                        <option value="">Select</option>
                        {politicalExposeOptions.map((item, index) => (
                          <option
                            key={`political_exposure_${index}`}
                            value={item}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                )}

                {profileData?.companyAdditionalDetails
                  ?.entity_registration_no && (
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Entity Registration No. (
                      {showRegistrationType(
                        profileData?.companyAdditionalDetails
                          ?.constitution_of_business
                      )}
                      )
                    </Label>
                    <Input
                      disabled
                      name="email"
                      type="text"
                      className="form-control"
                      value={
                        profileData?.companyAdditionalDetails
                          ?.constitution_of_business
                      }
                    />
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      {profileData?.bankDetails && (
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Bank Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Account Holders Name
                    </Label>
                    <Input
                      disabled
                      name="account_holder"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.account_holder}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Number</Label>
                    <Input
                      disabled
                      name="account_no"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.account_no}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Bank Name</Label>
                    <Input
                      disabled
                      name="bank_name"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.bank_name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">IFSC</Label>
                    <Input
                      disabled
                      name="ifsc"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.ifsc}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Account Type</Label>
                    <Input
                      disabled
                      name="account_type"
                      type="text"
                      className="form-control"
                      value={profileData?.bankDetails?.account_type || ""}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {profileData?.dematDetails && (
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Demat Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Demat Account Number
                    </Label>
                    <div className="input-wrapper">
                      <Input
                        disabled
                        name="demat_account_no"
                        type="text"
                        className="form-control"
                        value={profileData?.dematDetails.demat_account_no}
                      />
                    </div>
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Depository Participant Name
                    </Label>
                    <div className="input-wrapper">
                      <Select
                        isDisabled={true}
                        styles={reactSelectStyles}
                        options={depositories}
                        placeholder="Select Name"
                        value={getDepositoryParticipantValue()}
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                      />
                    </div>
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Depository Name</Label>
                    <div className="input-wrapper">
                      <Input
                        name="exchange_type"
                        type="text"
                        className="form-control"
                        disabled
                        value={profileData?.dematDetails.exchange_type}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {profileData?.aadhaarDetails && (
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Authorised Person Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">Name</Label>
                    <Input
                      disabled
                      name="demat_account_no"
                      type="text"
                      className="form-control"
                      value={profileData?.aadhaarDetails?.name}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Date of Birth</Label>
                    <Input
                      disabled
                      name="depository_participant_name"
                      type="text"
                      className="form-control"
                      value={profileData?.aadhaarDetails?.dob}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">PAN</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={profileData?.panDetails?.pan}
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Aadhaar No.</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={profileData?.aadhaarDetails?.aadhaar_no}
                    />
                  </Col>
                  {profileData?.companyAdditionalDetails?.designation && (
                    <Col xl={6}>
                      <Label className="col-form-label">Designation</Label>
                      <Input
                        disabled
                        name="exchange_type"
                        type="text"
                        className="form-control"
                        value={
                          profileData?.companyAdditionalDetails?.designation
                        }
                      />
                    </Col>
                  )}

                  {profileData?.companyAdditionalDetails?.dpin && (
                    <Col xl={6}>
                      <Label className="col-form-label">DIN</Label>
                      <Input
                        disabled
                        name="exchange_type"
                        type="text"
                        className="form-control"
                        value={
                          profileData?.companyAdditionalDetails?.dpin ??
                          "Not Applicable"
                        }
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Row>
        <Col xl={12}>
          {/* <CardTitle className="mt-4 mb-4">Documents</CardTitle> */}

          {hasBusinessFile() && (
            <>
              <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                Entity Documents
              </CardTitle>
              <div className="documents-section">
                {businessFiles.map((item, index) => (
                  <React.Fragment key={`businessFiles_${index}`}>
                    {profileData?.companyAdditionalDetails?.[item.key] && (
                      <div className="documents-box">
                        <div className="file-type">
                          {checkExtension(
                            profileData?.companyAdditionalDetails?.[item.key]
                          ) === "pdf" ? (
                            <img src={pdfIcon} alt="" />
                          ) : (
                            <img src={imageIcon} alt="" />
                          )}

                          <div>
                            <p>{item.label}</p>
                            <Link
                              to={`${
                                process.env.REACT_APP_FILE_URL
                              }/businessDocs/${
                                profileData?.companyAdditionalDetails?.[
                                  item.key
                                ]
                              }`}
                              target="_blank"
                            >
                              <span className="text-small text-success cursor-pointer">
                                View
                              </span>
                            </Link>
                          </div>
                        </div>
                        {/* <div className="verified-user">
                            <img src={check} alt="" /> Verified
                          </div> */}
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              <hr className="my-4" />
            </>
          )}
          {profileData?.aadhaarDetails && (
            <>
              <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                Authorised Person KYC
              </CardTitle>
              <div className="documents-section">
                {profileData?.aadhaarDetails?.aadhaar_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        profileData?.aadhaarDetails.aadhaar_file
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Aadhaar</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/aadhaar/${profileData?.aadhaarDetails.aadhaar_file}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                        <img src={check} alt="" /> Verified
                      </div> */}
                  </div>
                )}
                {profileData?.avatar && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.aadhaarDetails.image) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Selfie</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/aadhaar/${profileData?.aadhaarDetails.image}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                        <img src={check} alt="" /> Verified
                      </div> */}
                  </div>
                )}
                {profileData?.panDetails?.pan_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.panDetails?.pan_file) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>PAN</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/pan/${profileData?.panDetails.pan_file}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                        <img src={check} alt="" /> Verified
                      </div> */}
                  </div>
                )}

                {profileData?.companyAdditionalDetails?.authority_letter && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        profileData?.companyAdditionalDetails?.authority_letter
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Authority Letter</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/businessDocs/${profileData?.companyAdditionalDetails?.authority_letter}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                        <img src={check} alt="" /> Verified
                      </div> */}
                  </div>
                )}
              </div>
              <hr className="my-4" />
            </>
          )}
          {profileData?.bankDetails && (
            <>
              <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                Banking Documents
              </CardTitle>
              <div className="documents-section">
                {profileData?.dematDetails?.cml_report && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.dematDetails?.cml_report) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>CML Report</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/cml/${profileData?.aadhaarDetails.cml_report}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                        <img src={check} alt="" /> Verified
                      </div> */}
                  </div>
                )}
                {profileData?.bankDetails?.cheque_file && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(profileData?.bankDetails.cheque_file) ===
                      "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>Cheque</p>
                        <Link
                          to={`${process.env.REACT_APP_FILE_URL}/cheques/${profileData?.bankDetails.cheque_file}`}
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                        <img src={check} alt="" /> Verified
                      </div> */}
                  </div>
                )}
              </div>
            </>
          )}
        </Col>
      </Row>
    </>
  )
}

export default NonIndividualView
